module.exports = __webpack_public_path__ + "img/32.81733c63.png";